module.exports = __webpack_public_path__ + "static/pherobank-c6ce6ddee8c7cd99e5233ed56c459a3a.jpg";